import { timerKey } from '../../../utils/timer-manager/timer-manager';

/**
 * Horn controller
 *
 * @param rootStore
 * @param hornId
 * @param delay
 */
export const hornSwitch = (rootStore, hornId = null, delay = 3000) => {
  const { batchStore, devicesStore } = rootStore;
  if (hornId) {
    const horn = devicesStore.getDeviceById(hornId);
    if (!horn?.switchPNo) {
      return;
    }

    if (horn.autoTurnOn === false) {
      return;
    }

    batchStore.timers.clear(timerKey.custom('horn', hornId));

    const belt = devicesStore.devices.find(v => v.hornId === hornId);
    if (belt) {
      batchStore.setOutput(horn.switchPNo, belt.onDelay * 1000 || delay);
    }
  } else {
    const belts = devicesStore.devices.filter(v => v.hornId) || [];
    const horn = devicesStore.horns.find(v => !belts.find(b => b.hornId === v.id));

    if (!horn) {
      return;
    }

    if (horn.autoTurnOn === false) {
      return;
    }

    hornId = horn.id;
    batchStore.timers.clear(timerKey.custom('horn', hornId));

    batchStore.timers.set(timerKey.custom('horn', hornId), () => {
      batchStore.setOutput(horn.switchPNo, horn.delayOneDuration * 1000 || delay);

      batchStore.timers.set(timerKey.custom('horn', hornId),() => {
        if (horn.delayTwo) {
          batchStore.timers.set(timerKey.custom('horn', hornId),() => {
            batchStore.setOutput(horn.switchPNo, horn.delayTwoDuration * 1000 || delay);

            batchStore.timers.set(timerKey.custom('horn', hornId),() => {
              if (horn.delayThree) {
                batchStore.timers.set(timerKey.custom('horn', hornId),() => {
                  batchStore.setOutput(horn.switchPNo, horn.delayThreeDuration * 1000 || delay);
                }, horn.delayThree * 1000, 'horn delay three');
              }

            }, horn.delayTwoDuration * 1000 || delay, 'horn delay two duration');
          }, horn.delayTwo * 1000, 'horn delay two');
        }

      }, horn.delayOneDuration * 1000 || delay, 'horn delay one duration');
    }, horn.delayOne * 1000 || 0, 'horn delay one');

  }
};
